export default function Privacy() {
  return (
    <div className="privacy">
      <p>
        <b>Privacy Policy</b>
      </p>

      <p>
        At cowexchange.se, we are dedicated to safeguarding the privacy of our
        users and handling their information responsibly. This Privacy Policy
        governs the collection, usage, maintenance, and disclosure of
        information gathered from users (referred to as &quot;Users&quot;) of
        our website and all associated products and services.
      </p>

      <p>
        <b>1. Information We Collect:</b>
      </p>

      <ul>
        <li>
          <b>Personal Identification Information:</b> When Users interact with
          our website, we may collect personal identification information such
          as email addresses and optionally, names. This information is
          collected when subscribing to newsletters or opting-in to receive
          advertisements.
        </li>
        <li>
          <b>Non-Personal Identification Information:</b>
          Additionally, we may collect non-personal identification information
          about Users, including browser names, device types, and technical
          details about Users' connections to our website. This may involve the
          use of cookies and analytical tools to enhance user experience and
          understand website usage patterns.
        </li>
      </ul>

      <p>
        <b>2. Use of Collected Information:</b>
      </p>

      <ul>
        <li>
          <b>Email Addresses:</b> The email addresses provided by Users are used
          to send newsletters, updates, promotions, and advertisements. Users
          have the option to unsubscribe from these communications at any time.
        </li>
        <li>
          <b>Analytics and Cookies:</b> We utilize cookies and analytical tools
          to gather information about Users' interactions with our website. This
          data helps us improve our website functionality and tailor our content
          and advertisements to better suit Users' interests.
        </li>
      </ul>

      <p>
        <b>3. Protection of Your Information:</b>
      </p>

      <p>
        We employ appropriate data collection, storage, and processing
        practices, along with security measures, to prevent unauthorized access,
        alteration, disclosure, or destruction of Users' personal information,
        including usernames, passwords, and transaction details.
      </p>

      <p>
        <b>
          <br />
          4. Financial Information Handling:
        </b>
      </p>

      <ul>
        <li>
          <b>Collection:</b> We collect specific financial data related to the
          currencies Users hold, the amounts they possess, and their preferred
          currencies for potential purchases. Additionally, we store information
          regarding the duration of investment terms Users are interested in.
        </li>
        <li>
          <b>Usage:</b> The financial information we gather is utilized solely
          for the purpose of providing tailored services to Users. This includes
          facilitating currency transactions, assisting in investment decisions,
          and optimizing the user experience based on their investment
          preferences.
        </li>
        <li>
          <b>Security Measures:</b> We employ robust security measures to
          safeguard Users' financial data, utilizing encryption and
          industry-standard protocols to prevent unauthorized access,
          alteration, or disclosure.
        </li>
        <li>
          <b>Third-Party Disclosure:</b> We do not share Users' financial
          information with third parties without explicit consent, except when
          necessary to fulfill user requests or comply with legal requirements.
        </li>
      </ul>

      <p>
        <b>5. Your Consent:</b>
      </p>

      <p>
        By using our website, you consent to the collection, usage, and
        disclosure of your information as described in this Privacy Policy. If
        you do not agree with these terms, please refrain from using our
        website.
      </p>

      <p>
        <b>6. Changes to This Privacy Policy:</b>
      </p>

      <p>
        We reserve the right to update or modify this Privacy Policy at any time
        without prior notice. Any changes will be effective immediately upon
        posting the updated Privacy Policy on this page.
      </p>

      <p>
        <b>7. Contact Us:</b>
      </p>

      <p>
        If you have any questions or concerns about our Privacy Policy or the
        handling of your information, please contact us at [Contact
        Information].
      </p>

      <p>
        <b>Last Updated: 2024/02/28</b>
      </p>
    </div>
  );
}
